// Elementos HTML
const settingsSecctions = document.querySelectorAll<HTMLDivElement>('.hidden-content')!;

export function main() {
  settingsSecctions.forEach(secction => {
    const icon = secction.querySelector<HTMLSpanElement>('.icon')!;
    const article = secction.querySelector('article')!;

    icon.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;

      // Solo abrir si está cerrada
      if (target.classList.contains('bi-chevron-bar-down')) {
        // 🔒 Cierra todas las demás secciones primero
        settingsSecctions.forEach(s => {
          const otherIcon = s.querySelector<HTMLSpanElement>('.icon')!;
          const otherArticle = s.querySelector<HTMLElement>('article')!;

          otherIcon.classList.remove('bi-chevron-bar-up');
          otherIcon.classList.add('bi-chevron-bar-down');

          otherArticle.classList.remove('visible');
          otherArticle.classList.add('oculto');
        });

        // 🔓 Abre la seleccionada
        target.classList.add('bi-chevron-bar-up');
        target.classList.remove('bi-chevron-bar-down');

        article.classList.remove('oculto');
        article.classList.add('visible');
      } else {
        // Si ya está abierta, simplemente ciérrala
        target.classList.remove('bi-chevron-bar-up');
        target.classList.add('bi-chevron-bar-down');

        article.classList.remove('visible');
        article.classList.add('oculto');
      }
    });
  });
}